import { useEffect, useState, useRef } from 'react';
import { Layout, Breadcrumb, Col, Row, Space, Avatar, Button, Popconfirm } from 'antd';
import SiderMenu from './components/system/SiderMenu';
import {
    useNavigate,
    useLocation,
    Outlet
} from "react-router-dom";

const { Header, Content, Footer, Sider } = Layout;

const AppBm = (props: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const contentRef = useRef<HTMLElement>(null); // 右侧内容滚动容器
    const [collapsed, setCollapsed] = useState(false);

    const onCollapse = (collapsed: any) => {
        setCollapsed(collapsed);
    };

    const exit = () => {
        if (localStorage.getItem('token')) {
            localStorage.clear();
            navigate('/login');
        } else {
            sessionStorage.clear();
            navigate('/login');
        }
    };

    // 监听路由变化：点击菜单时，只让右侧内容回到顶部，左侧菜单不动
    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTo({ top: 0, left: 0 });
        }
    }, [location.pathname]);

    return (
        // 1. 最外层 Layout：固定 100vh 高度，禁止整体滚动
        <Layout style={{ height: '100vh', overflow: 'hidden' }}>

            {/* 2. 左侧 Sider：添加 custom-sider-menu 类名，开启纵向滚动 */}
            <Sider
                collapsible
                collapsed={collapsed}
                onCollapse={onCollapse}
                className="custom-sider-menu"
                style={{ overflowY: 'auto', overflowX: 'hidden' }}
            >
                <div className="logo" style={{ textAlign: 'center', lineHeight: "32px" }}> 菜单</div>
                <SiderMenu />
            </Sider>

            {/* 3. 右侧 Layout：占据剩余高度，隐藏外层滚动 */}
            <Layout className="site-layout" style={{ color: "#fff", height: '100%', overflow: 'hidden' }}>
                <Header className="site-layout-background" style={{ padding: 0, height: '8vh', verticalAlign: 'middle' }}>
                    <Row>
                        <Col span={6} >
                            <Breadcrumb />
                        </Col>
                        <Col span={18} >
                            <div className="header-right">
                                <Space>
                                    <Avatar size={30} style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>USER</Avatar>
                                    <Popconfirm title="确定要退出登录吗？" onConfirm={exit} okText="确定" cancelText="取消">
                                        <div className='exit' style={{ color: "#1d5edc", cursor: 'pointer' }} >登出</div>
                                    </Popconfirm>
                                </Space>
                            </div>
                        </Col>
                    </Row>
                </Header>

                {/* 4. Content：添加 custom-content-scroll 类名，开启独立滚动，挂载 ref */}
                <Content
                    ref={contentRef}
                    className="custom-content-scroll"
                    style={{ margin: '0 16px', overflowY: 'auto' }}
                >
                    <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                        <Outlet />
                    </div>
                </Content>

                <Footer style={{ textAlign: 'center' }}>©2023 CopyRight BrandName</Footer>
            </Layout>
        </Layout>
    )
};

export default AppBm;